import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserFlows } from "redux/actions/portal/flowsActionCreator";

let isFetching = false;

export const useUserFlows = () => {
  const { user } = useAuth0();
  const { userFlows } = useSelector((store) => store?.portal?.flows);
  const dispatch = useDispatch();

  const handleFetchUserFlows = () => {
    dispatch(fetchUserFlows(user?.stripeId));
  };

  useEffect(() => {
    if (isFetching || !user?.stripeId || userFlows?.length) return;
    isFetching = true;

    handleFetchUserFlows();
  }, [user?.stripeId]);

  return {
    userFlows,
    handleFetchUserFlows,
  };
};
